import request from "@assets/js/axios";
const { instance: $axios } = request;
class User {
  constructor() {}
  // 更新地址
  updateAddress (data) {
    return $axios.post('/api/v1/address/'+data.id, {
      ...data,
      _method: 'PUT'
    })
  }
  // 删除地址
  deleteAddress(id) {
    return $axios.post("/api/v1/address/" + id, {
      id,
      _method: "DELETE",
    });
  }
  // 获取地址列表
  getAddress() {
    return $axios.get("/api/v1/address/byUserId");
  }
  // 添加地址
  addAddress(data) {
    return $axios.post("/api/v1/address/store", data);
  }
  // 注册
  register({ phone, code, password }) {
    return $axios.post("/user/storeByIp", {
      phoneNumber: phone,
      phoneCode: code,
      password,
    });
  }
  // 登录
  login(data) {
    return $axios.post("/user/onLogin", data);
  }
  signOut () {
    return $axios.get('/logout');
  }
  // 发送短信验证码
  sendSMS(phone) {
    return $axios.post("/user/getPhoneCodeByIp", { phoneNumber: phone });
  }
}

export default new User();